var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { id: "sidebar" } }, [
    _c(
      "ul",
      { staticClass: "col-md-12 no-padding sidebar-menu" },
      [
        _c(
          "li",
          {
            attrs: { id: "btn-expand-sidebar-toggle" },
            on: { click: _vm.sidebarToggle }
          },
          [
            _c("a", [
              _c("i", { staticClass: "icon fold fas fa-angle-double-left" }),
              _vm._v(" "),
              _c("i", { staticClass: "icon expend fas fa-angle-double-right" }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("message.short_menu")))]),
              _vm._v(" "),
              _c("i", { staticClass: "fas fa-angle-left" })
            ])
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.$store.state.app.sidebar, function(item, index) {
          return [
            item.submenus !== undefined
              ? [
                  _c(
                    "li",
                    {
                      class: [
                        "sub-menu " + item.activeClass,
                        { hide: item.show === false }
                      ]
                    },
                    [
                      _c("a", [
                        _c("i", { class: "icon " + item.icon }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t(item.name)))]),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-circle current" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-angle-left" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "line-left" }),
                        _vm._v(" "),
                        _c("i", { staticClass: "line-bottom" })
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(item.submenus, function(item_, index_) {
                          return _c(
                            "li",
                            {
                              key: index_,
                              class: [
                                item_.activeClass,
                                { hide: item_.show === false }
                              ]
                            },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: item_.router.name,
                                      query: item_.router.query || null
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t(item_.name)))
                                  ]),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "fas fa-circle" }),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "line-left" }),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "line-bottom" })
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            item.submenus === undefined
              ? [
                  _c(
                    "li",
                    {
                      class: [
                        "no-sub-menu " + item.activeClass,
                        { hide: item.show === false }
                      ]
                    },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            to: {
                              name: item.router.name,
                              query: item.router.query
                            }
                          }
                        },
                        [
                          _c("i", { class: "icon " + item.icon }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$t(item.name)))]),
                          _vm._v(" "),
                          _c("i", { staticClass: "fas fa-circle current" }),
                          _vm._v(" "),
                          _c("i", { staticClass: "line-left" })
                        ]
                      )
                    ],
                    1
                  )
                ]
              : _vm._e()
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "overlay" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-658d17d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-658d17d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/SideBar.vue
// module id = null
// module chunks = 